import React from 'react';
import { motion } from 'framer-motion';
import { LuLocate, LuMailOpen, LuPhoneCall } from 'react-icons/lu';
import './Footer.css';

const FOOTER_LINKS = [
  {
    title: 'Services',
    links: ['Transport des animaux vivants', 'Expédition des colis', 'Suivi en temps réel des animaux', 'Suivi en temps réel des colis'],
  },
  {
    title: 'Destinations',
    links: ['Amériques', 'Europe', 'Asie-Pacifique', 'Afrique & Moyen-Orient'],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Top row */}
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={require('../../assets/monLogo2.png')} alt="Logo" className='monlogo'/>
              <span className="logo-text">
                <span className="logo-brand-text">Air transport</span>
                <span className="logo-tagline">Animalier</span>
              </span>
            </div>
            <p className="footer-tagline">
              Le transport d'animaux à l'international, avec l'expertise et le soin qu'ils méritent.
            </p>
          </div>

          {/* Links */}
          <div className="footer-links-grid">
            {FOOTER_LINKS.map((col) => (
              <div key={col.title} className="footer-col">
                <h4 className="footer-col-title">{col.title}</h4>
                <ul>
                  {col.links.map((link) => (
                    <li key={link}>
                      <a href="#" className="footer-link">{link}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Contact rapide */}
          <div className="footer-contact">
            <h4 className="footer-col-title">Contact</h4>
            <div className="footer-contact-items">
              <div className="footer-contact-item">
                <LuPhoneCall className="footer-icon"/>
                <span>+33 7 56 85 25 52</span>
              </div>
              <div className="footer-contact-item">
                <LuMailOpen className="footer-icon"/>
                <span><a href="mailto:hello@air-transport-animalier.com">hello@air-transport-animalier.com</a></span>
              </div>
              <div className="footer-contact-item">
                <LuMailOpen className="footer-icon"/>
                <span><a href="mailto:transportdesanimaux@air-transport-animalier.com">transportdesanimaux@air-transport-animalier.com</a></span>
              </div>
              <div className="footer-contact-item">
                <LuLocate className="footer-icon"/>
                <span>15 quai Rauba Capéu 06300 Nice</span>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom row */}
        <div className="footer-bottom">
          <p className="footer-copy">
            © {year} Air transport animalier. Tous droits réservés.
          </p>
          <div className="footer-bottom-links">
            <a href="#">Politique de confidentialité</a>
            <a href="#">CGV</a>
            <a href="#">Cookies</a>
          </div>
          <p className="footer-made">
            Spécialiste transport animal depuis 2008 🐾
          </p>
        </div>
      </div>
    </footer>
  );
}
